
// Base.
import {Prop, Mixins} from 'vue-property-decorator'
import Component from 'vue-class-component'
import usersMixins from '../Users/UsersMixin'
// Used for notifications.
import UserService from '@/services/UserService'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '@/components/Atomic/CardTitle.vue'
// Used Models.
import {Extra, User} from '@/models/user'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

import XLSX from 'xlsx'
import ToolTipBlueButton from '@/components/Atomic/ToolTipButton.vue'

interface StudentData {
    ad_personne_id: number
    password: string
}

@Component({
    components: {
        ToolTipBlueButton,
        ProgressLinear,
        BlueButton,
        RedButton,
        GreenButton,
        CardTitle,
    },
})
export default class CsvExport extends Mixins(usersMixins) {
    private errorHandlerService = new ErrorHandlerService()
    // Used for CSV Export.
    private jsonMeta: any = [{key: 'charset', value: 'utf-8'}]
    private jsonFields: any = {}

    @Prop() private readonly getJsonData!: Extra[]
    @Prop() private readonly users!: Extra[]
    @Prop() private mainWindowPending: boolean
    @Prop() private iconSize?: number

    private exportToExcel: boolean = true
    private formatSelection: Array<{ text: string, value: boolean }> = [{
        text: 'Excel (XLSX)',
        value: true
    }, {text: 'CSV', value: false}]
    private excelHeaders: {} = {}

    private get hasNoUsersOrPending() {
        if (!this.isPending) {
            return this.users.length === 0
        }
        return false
    }

    public mounted() {
        this.initialize()
    }

    private initialize() {
        this.setCsvExportConfig()
        this.setExcelExportConfig()
    }

    private setCsvExportConfig() {
        this.jsonFields[this.$t('ExtraPersonneID').toString()] = 'personne_ia_id'
        this.jsonFields[this.$t('PersonneID').toString()] = 'personne_id'
        this.jsonFields[this.$t('Gender').toString()] = 'genre'
        this.jsonFields[this.$t('FirstName').toString()] = 'prenom'
        this.jsonFields[this.$t('Name').toString()] = 'nom'
        this.jsonFields[this.$t('Username').toString()] = 'iup'
        this.jsonFields[this.$t('Email').toString()] = 'courriel'
        this.jsonFields[this.$t('BirthDate').toString()] = 'date_naissance'
        this.jsonFields[this.$t('EXTRAS.Licence').toString()] = 'licence'
        this.jsonFields[this.$t('EXTRAS.Authority').toString()] = 'authority'
        this.jsonFields[this.$t('EXTRAS.Department').toString()] = 'department'
        this.jsonFields[this.$t('EXTRAS.Entity').toString()] = 'entity'
        this.jsonFields[this.$t('EXTRAS.Unit').toString()] = 'unit'
        this.jsonFields[this.$t('EXTRAS.JobTitle').toString()] = 'fonction'
        this.jsonFields[this.$t('EstablishmentId').toString()] = 'school_ids'
        this.jsonFields[this.$t('EXTRAS.DataSteward').toString()] = 'data_steward'

    }

    private setExcelExportConfig() {
        this.excelHeaders['personne_ia_id'] = this.$t('ExtraPersonneID').toString()
        this.excelHeaders['personne_id'] = this.$t('PersonneID').toString()
        this.excelHeaders['genre'] = this.$t('Gender').toString()
        this.excelHeaders['nom'] = this.$t('Name').toString()
        this.excelHeaders['prenom'] = this.$t('FirstName').toString()
        this.excelHeaders['iup'] = this.$t('Username').toString()
        this.excelHeaders['courriel'] = this.$t('Email').toString()
        this.excelHeaders['date_naissance'] = this.$t('BirthDate').toString()
        this.excelHeaders['licence'] = this.$t('EXTRAS.Licence').toString()
        this.excelHeaders['authority'] = this.$t('EXTRAS.Authority').toString()
        this.excelHeaders['department'] = this.$t('EXTRAS.Department').toString()
        this.excelHeaders['entity'] = this.$t('EXTRAS.Entity').toString()
        this.excelHeaders['unit'] = this.$t('EXTRAS.Unit').toString()
        this.excelHeaders['fonction'] = this.$t('EXTRAS.JobTitle').toString()
        this.excelHeaders['school_ids'] = this.$t('EstablishmentId').toString()
        this.excelHeaders['data_steward'] = this.$t('EXTRAS.DataSteward').toString()

    }
    private async exportData() {
        const workbook = XLSX.utils.book_new()
        const usersToExport = await this.changeUserAttrForExport()
        const sheetData = XLSX.utils.json_to_sheet(usersToExport, {header: Object.keys(this.jsonFields)})
        this.dialog = false
        if(this.exportToExcel){
            XLSX.utils.book_append_sheet(workbook, sheetData)
            XLSX.writeFile(workbook, 'extra.xlsx')
        }
        else {
            XLSX.utils.sheet_to_csv(sheetData)
            XLSX.utils.book_append_sheet(workbook, sheetData)
            XLSX.writeFile(workbook, 'extra.csv')
        }
    }

    private async changeUserAttrForExport() {
        let users
        if (this.getJsonData.length === 0) {
            users = this.users.map((user) => Object.assign({}, user))
        } else {
            users = this.getJsonData.map((user) => Object.assign({}, user))
        }
        users.map((user: Extra) => {
            Object.keys(user).forEach((key) => {
                if (this.excelHeaders[key] !== undefined) {
                    if (key === 'school_ids') {
                        if (Array.isArray(user[key]) && user[key].length > 0) {
                            user[this.excelHeaders[key]] = user[key].join(';')
                        }
                    }
                    else if (key === 'data_steward'){
                        user[this.excelHeaders[key]] = user.data_steward ? 'Oui': 'Non'
                    }
                    else {
                        user[this.excelHeaders[key]] = user[key]
                    }
                }
                delete user[key]
            })
        })
        return users
    }

    private abort() {
        this.exportToExcel = true
        this.cancel()
    }
}
